import React, { useEffect, useRef, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Card,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    CardBody,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Progress
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faSearch, faTv } from "@fortawesome/free-solid-svg-icons";
import { Map, TileLayer, Marker, GeoJSON, Tooltip, Polyline, Popup } from 'react-leaflet'
import L from 'leaflet'
import Select from 'react-select'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import MarkerClusterGroup from "react-leaflet-markercluster";

// style
import "../../../assets/css/loading.css";
import "../../../assets/css/map.css";
import "../../../assets/css/mapAnaliseOrdem.css";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

// views
import ModalDetalhesInconformidade from "./ModalDetalhesInconformidade.jsx"
import ModalAcoesColetor from "../../shared/ModalAcoesColetor";
import ModalDetalhesColetaItem from "../../shared/ModalDetalhesColetaItem";

// helpers
import useInterval from "../../../helpers/useInterval.js";
import { formateDateandTimeComplete } from "../../../helpers/formats";
import moment from "moment";

export default function Monitoramento({ history }) {
    const session = getSessionCookie();

    const [showLoading, setshowLoading] = useState(false);

    const [centerMap, setcenterMap] = useState([-3.7281458, -38.5762694]);

    const [regionalJson, setregionalJson] = useState(null);
    const [territorioJson, setterritorioJson] = useState(null);
    const [planoTrabalhoJson, setPlanoTrabalhoJson] = useState(null);

    const [delimitacao, setdelimitacao] = useState("");
    const [options_delimitacao] = useState([
        { label: "Nenhum", value: "" },
        { label: "Divisão Administrativa", value: "Regional" },
        { label: "Área Operacional", value: "Território" },
        { label: "Plano de trabalho", value: "Plano" }
    ]);

    //State para controller do check
    const [rastreiaRecurs, setRastreiaRecurso] = useState(false);

    //State para contralar modal
    const [modalAcoesMonitoramnento, setModalAcoesMonitoramento] = useState(false);

    //State para pegar o ponto do local
    const [pontoColetaSituacao, setPontoColetaSituacao] = useState(null);

    //Função para alteração do modal de visiblidade
    const toggleModalLocalizarRecurso = () => {
        setModalAcoesMonitoramento(!modalAcoesMonitoramnento)
    };

    //State para controlar o modal da acao do gestor
    const [stateModalAcaoGesto, setStateModalAcaoGesto] = useState(false);

    //Função para alteração do modal de visiblidade
    const toggleModalAcaoGesto = () => {
        setOrdemColeta(null);
        setStateModalAcaoGesto(!stateModalAcaoGesto);
    }

    //State para controlar o modal do ponto de coleta
    const [modalPontoColeta, setModalPontoColeta] = useState(false);

    const toggleModalPontoColeta = () => {
        setModalPontoColeta(!modalPontoColeta);
        setOrdemColeta(null);
    }

    const [modalRastreiaRecurso, setModalRastreiaRecurso] = useState(false);
    // funcao para mudar o modal
    const toggleModalRastreio = () => setModalRastreiaRecurso(!modalRastreiaRecurso);

    const [checkAcoesColetoOcorrencia, setCheckAcoesColetoOcorrencia] = useState(false);

    const handleDelimitacao = (value) => {
        setdelimitacao(value);
        if (value == "Regional" && regionalJson == null) {
            if (localStorage.getItem("regionais") != null) {
                setregionalJson(JSON.parse(localStorage.getItem("regionais")));
            }
            else {
                setshowLoading(true);
                api_GET('regional/GetWithGeoJson').then(result => {
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        localStorage.setItem("regionais", JSON.stringify(result.data));
                        setregionalJson(result.data);
                    }
                });
            }
        }
        if (value == "Território" && territorioJson == null) {
            if (localStorage.getItem("territorios") != null) {
                setterritorioJson(JSON.parse(localStorage.getItem("territorios")));
            }
            else {
                setshowLoading(true);
                api_GET('territorio/GetWithGeoJson').then(result => {
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        localStorage.setItem("territorios", JSON.stringify(result.data));
                        setterritorioJson(result.data);
                    }
                });
            }
        }
        if (value == "Plano" && planoTrabalhoJson == null) {
            if (modalidadeColeta != null && modalidadeColeta.modalidadeColetaId == null) {
                showMessage("Aviso", "Para visualizar a delimitação no plano de trabalho, escolha a modalidade no filtro.", 'warning', null);
                return;
            }
            setshowLoading(true);
            api_GET(`modalidadeColeta/GetListDelimitacaoGeograficaSetor/${modalidadeColeta.modalidadeColetaId}`).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Não foi possível consultar as delimitações geográficas", result.message, 'error', null);
                }
                else {
                    localStorage.setItem("planos", JSON.stringify(result.data));
                    setPlanoTrabalhoJson(result.data);
                }
            });
        }
    }

    const [viewPontos, setviewPontos] = useState(false);
    const [viewRota, setviewRota] = useState(false);
    const [viewAlertas, setviewAlertas] = useState(true);
    const [viewInconformidade, setviewInconformidade] = useState(false);


    const [showFiltros, setshowFiltros] = useState(false);

    // Modalidade
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
    const [modalidadeColeta, setModalidadeColeta] = useState({ modalidadeColetaId: null, descricao: "Todas" });
    const loadOptionsModalidadesColeta = () => {
        let endpoint = "modalidadeColeta"
        if (session.concessionariaId != null)
            endpoint += `/GetByConcessionaria/${session.concessionariaId}`;

        api_GET(endpoint).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                result.data.push({ modalidadeColetaId: null, descricao: "Todas" })
                setoptionsModalidadesColeta(result.data);
            }
        });
    }

    // Regional = Divisão Administrativa
    const [optionsRegional, setOptionsRegional] = useState([]);
    const [regional, setRegional] = React.useState([]);
    const loadOptionsRegional = () => {
        if (localStorage.getItem("regionais") != null) {
            setOptionsRegional(JSON.parse(localStorage.getItem("regionais")));
        }
        else {
            api_GET(`regional`).then(result => {
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    setOptionsRegional(result.data);
                }
            });
        }
    }

    // Setor
    const [optionsSetor, setOptionsSetor] = React.useState([]);
    const [setor, setSetor] = React.useState({ setorColetaId: null, descricao: "Todos" });
    const loadOptionsSetor = () => {
        let endpoint = "setorcoleta";
        if (session.concessionariaId != null)
            endpoint += `/GetByConcessionaria/${session.concessionariaId}`;

        api_GET(endpoint).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                result.data.push({ setorColetaId: null, descricao: "Todos" });
                setOptionsSetor(result.data);
            }
        });
    }

    // Veiculo
    const [optionsVeiculo, setOptionsVeiculo] = React.useState([]);
    const [veiculo, setVeiculo] = React.useState({ veiculoId: null, placa: "Todos" });
    const loadOptionsVeiculo = () => {
        let endpoint = "veiculo";
        if (session.concessionariaId != null)
            endpoint += `/GetByConcessionaria/${session.concessionariaId}`;
        else
            endpoint += "/GetAllAtivos";
        api_GET(endpoint).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                result.data.push({ veiculoId: null, placa: "Todos" });
                setOptionsVeiculo(result.data);
            }
        });
    }

    const [monitoramento, setMonitoramento] = React.useState(null);
    const GetMonitoramento = () => {
        let regionais = [];
        regional.map(m => { regionais.push(m.regionalId) })

        let json_post = {
            concessionariaId: session.concessionariaId,
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            setorColetaId: setor.setorColetaId,
            veiculoId: veiculo.veiculoId,
            regionalId: regionais,
            dataProgramacao: moment().format("YYYY-MM-DD")
        }

        setshowLoading(true);

        api_POST('monitoramento/filtro', json_post).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setMonitoramento(result.data);
            }
        });
    }

    // Icones    
    const handleIconColeta = (item) => {
        let icon = "";
        if (item.statusColeta == "Programada")
            icon = "planotrabalho-azul"
        else if (item.statusColeta == "Execução Iniciada")
            icon = "planotrabalho-roxo"
        else if (item.statusColeta == "Execução Parcial")
            icon = "planotrabalho-amarelo"
        else if (item.statusColeta == "Execução Total")
            icon = "planotrabalho-verde"
        else if (item.statusColeta == "Não Execução")
            icon = "planotrabalho-vermelho"
        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png'),
        });
    }

    const handleIconInconformidade = (item) => {
        let icon = "";
        if (item.situacao == "Aguardando Contestação")
            icon = "inconformidade-azul"
        else if (item.situacao == "Aguardando Justificativa")
            icon = "inconformidade-amarelo"
        else if (item.situacao == "Aguardando Avaliação de Justificativa")
            icon = "inconformidade-roxo"
        else if (item.situacao == "Justificativa Aprovada")
            icon = "inconformidade-verde"
        else if (item.situacao == "Justificativa Reprovada")
            icon = "inconformidade-vermelho"

        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconSize: [28, 33],
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png')
        });
    }

    const handleIconLocalizaRecurso = () => {
        return new L.Icon({
            iconUrl: require('assets/img/icons/veiculo-azul.png'),
            iconRetinaUrl: require('assets/img/icons/veiculo-azul.png'),
        });
    }

    const handleIconRastreio = () => {
        return new L.Icon({
            iconUrl: require('assets/img/icons/point.png'),
            iconRetinaUrl: require('assets/img/icons/point.png'),
            iconSize: [22, 27],
        });
    }

    const handleIconAlerta = (item) => {
        let icon = "";
        if (item.situacao == "Aguardando Contestação")
            icon = "alerta-azul"
        else if (item.situacao == "Aguardando Justificativa")
            icon = "alerta-amarelo"
        else if (item.situacao == "Aguardando Avaliação de Justificativa")
            icon = "alerta-roxo"
        else if (item.situacao == "Justificativa Aprovada")
            icon = "alerta-verde"
        else if (item.situacao == "Justificativa Reprovada")
            icon = "alerta-vermelho"

        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconSize: [28, 33],
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png')
        });
    }

    // Detalhes da Inconformidade
    const [stateModalDetalhesInconformidade, setstateModalDetalhesInconformidade] = React.useState(false);
    const [itemModalDetalhesInconformidade, setItemModalDetalhesInconformidade] = React.useState(null);
    const openModalDetalhesInconformidade = (inconformidade) => {
        setItemModalDetalhesInconformidade(inconformidade);
        setstateModalDetalhesInconformidade(true);
    }
    const ReturnModalDetalhesInconformidade = () => {
        setstateModalDetalhesInconformidade(false);
    }

    const [showLegendas, setShowLegendas] = React.useState(false);
    const [mapaSatelite, setmapaSatelite] = React.useState(false);

    useEffect(() => {
        loadOptionsRegional();
        loadOptionsModalidadesColeta();
        loadOptionsSetor();
        loadOptionsVeiculo();
        GetMonitoramento();
    }, []);


    useInterval(GetMonitoramento, 120000);

    const OpenTV = () => {
        let url = 'monitoramentoTV?';

        if (modalidadeColeta.modalidadeColetaId != null)
            url += 'modalidadeColetaId=' + modalidadeColeta.modalidadeColetaId + "&";
        if (setor.setorColetaId != null)
            url += 'setorColetaId=' + setor.setorColetaId + "&";
        if (veiculo.veiculoId != null)
            url += 'veiculoId=' + veiculo.veiculoId + "&";
        if (delimitacao != "")
            url += 'delimitacao=' + delimitacao + "&"
        if (viewPontos)
            url += 'viewPontos=true&';
        if (viewAlertas)
            url += 'viewAlertas=true&';
        if (regional.length > 0) {
            let regionais = "";
            regional.map(m => regionais += "-" + m.regionalId);
            url += 'regionais=' + regionais;
        }

        window.open(url);
    }

    const [ordemColeta, setOrdemColeta] = useState(null);
    const loadOrdemColeta = (ordemColetaId) => {
        setshowLoading(true);
        api_GET(`ordemcoleta/${ordemColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOrdemColeta(result.data);
                setStateModalAcaoGesto(true);
            }
        });
    }

    const [lineRastreio, setLineRastreio] = useState([]);
    const [dadosRastreamento, setDadosRastreamento] = useState([]);
    const createPolyline = (data) => {
        const polyline = [];
        for (let i = 1; i < data.length; i++) {
            polyline.push({
                from_lat: data[i - 1].latitude,
                from_long: data[i - 1].longitude,
                id: i - 1,
                to_lat: data[i].latitude,
                to_long: data[i].longitude,
            });
        }
        return polyline;
    };

    const loadRastreamentoVeiculo = (ordemColetaId, ativo) => {
        if (ativo) {
            setshowLoading(true);
            api_GET(`Monitoramento/GetAtualizarRastreioMonitoramneto/${ordemColetaId}`).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                    return;
                }
                else {
                    if (result.data?.length > 0) {
                        let lines = createPolyline(result.data);
                        setDadosRastreamento(result.data);
                        setLineRastreio(lines);
                        setcenterMap([result.data[0].latitude, result.data[0].longitude]);
                    } else {
                        showMessage("Atenção", "Não existe rastreio para este recurso.", 'warning', null);
                        return;
                    }
                }
            });
        }
    }

    const loadPontoColeta = (ordemColetaPontoColetaId) => {
        setshowLoading(true);
        api_GET(`Monitoramento/GetLocalColetaMonitoramento/${ordemColetaPontoColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                setPontoColetaSituacao(result.data);
                setModalPontoColeta(true);
            }
        });
    }

    // state para mostrar informaçoes sobre rastreio
    const [dadoVeiculo, setDadoVeiculo] = useState({
        datahora: "",
        tipoRastreio: "",
        placa: ""
    })
    // componente para exibir o modal do rastreio
    const ModalMarkup = () => {
        return <Modal isOpen={modalRastreiaRecurso} toggle={toggleModalRastreio} centered>
            <ModalHeader toggle={toggleModalRastreio} close={<div style={{ display: 'none' }}></div>}>Origem Rastreio</ModalHeader>
            <ModalBody>
                <Row className="mb-2">
                    <Col md={"6"}>
                        Data/Hora Rastreio
                    </Col>
                    <Col md={"6"}>
                        Status
                    </Col>
                </Row>
                <Row>
                    <Col md={"6"}>
                        <Input
                            disabled
                            value={formateDateandTimeComplete(dadoVeiculo.datahora)}
                        />
                    </Col>
                    <Col md={"6"}>
                        <Input
                            disabled
                            value={dadoVeiculo.tipoRastreio}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={toggleModalRastreio}>
                    Fechar
                </Button>
            </ModalFooter>
        </Modal>
    }

    const [resumoSetorColeta, setResumoSetorColeta] = useState(null);
    const loadResumoSetor = ({ delimitacaoGeograficaSetorId, descricao, modalidadeColetaId }) => {
        setshowLoading(true);
        api_POST('monitoramento/ResumoSetorMonitoramento', { delimitacaoGeograficaSetorId: delimitacaoGeograficaSetorId, descricao: descricao, modalidadeColetaId: modalidadeColetaId }).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                setResumoSetorColeta(result.data);
                setModalAcoesMonitoramento(true);
            }
        });
    }

    const [acoesColetoCorrencia, setAcoesColetoCorrencia] = useState([]);
    const loadAcoesColetoCorrencia = (ordemColetaId) => {
        setshowLoading(true);
        api_GET(`Monitoramento/GetAcoesColetaCorrenciaMonitoramento/${ordemColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                setAcoesColetoCorrencia(result.data)
            }
        });
    }

    const handleIconAcoesColetor = (item) => {
        let icon = "";
        if (item.tipoAcao == "Início da Execução" || item.tipoAcao == "Reinício da Execução")
            icon = "marker-start";
        else if (item.tipoAcao == "Pausa da Execução")
            icon = "marker-pause";
        else if (item.tipoAcao == "Suspensão da Execução" || item.tipoAcao == "Finalização Manual" || item.tipoAcao == "Finalização Automática")
            icon = "marker-close";
        else if (item.tipoAcao == "Ocorrência")
            icon = "marker-ocurrency";
        else if (item.tipoAcao == "Destinação")
            icon = "marker-destination";
        else if (item.tipoAcao == "Descarregar" || item.tipoAcao == "Descarregar Sem Comprovante")
            icon = "marker-unload";

        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconSize: [32, 40],
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png'),
        });
    }

    // Ações Coletor
    const [ordemColetaAcaoColetorId, setordemColetaAcaoColetorId] = useState(null);
    const openModalAcoesColetor = (acao) => {
        loadOrdemColeta(acao.ordemColetaId);
        setordemColetaAcaoColetorId(acao != null ? acao.ordemColetaAcaoColetorId : null);
        setStateModalAcaoGesto(true);
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <div>
                <Container className="mt-2" fluid>
                    <Card className="shadow">
                        <CardBody>
                            <Row>
                                <Col md="12">
                                    <Button
                                        color="info"
                                        outline
                                        className="btn-sm"
                                        type="button"
                                        onClick={() => setshowFiltros(!showFiltros)}
                                    >
                                        Filtros
                                    </Button>
                                </Col>
                            </Row>
                            {showFiltros &&
                                <Row>
                                    <Col md="12" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Modalidade de Serviço
                                            </label>
                                            <Select
                                                name="modalidadeColeta"
                                                options={optionsModalidadesColeta}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                onChange={(value) => {
                                                    setModalidadeColeta(value)
                                                    setPlanoTrabalhoJson(null);
                                                    setdelimitacao("")
                                                }}
                                                value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                                                placeholder="Selecione"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="12" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Divisão Administrativa
                                            </label>
                                            <Select
                                                options={optionsRegional}
                                                name="regional"
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ regionalId }) => regionalId}
                                                onChange={(value) => { setRegional(value || []) }}
                                                value={optionsRegional.filter(({ regionalId }) => regional != null && regional.filter(f => f.regionalId == regionalId).length > 0)}
                                                placeholder="Todas"
                                                isMulti="true"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Plano de Trabalho
                                            </label>
                                            <Select
                                                name="setor"
                                                options={optionsSetor}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ setorColetaId }) => setorColetaId}
                                                onChange={(value) => { setSetor(value) }}
                                                value={setor != null && optionsSetor.find(obj => obj.setorColetaId === setor.setorColetaId)}
                                                placeholder="Selecione"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Recurso
                                            </label>
                                            <Select
                                                name="veiculo"
                                                options={optionsVeiculo}
                                                getOptionLabel={({ placa }) => placa}
                                                getOptionValue={({ veiculoId }) => veiculoId}
                                                onChange={(value) => { setVeiculo(value) }}
                                                value={veiculo != null && optionsVeiculo.find(obj => obj.veiculoId === veiculo.veiculoId)}
                                                placeholder="Selecione"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <br />
                                        <Button
                                            outline
                                            color="info"
                                            type="button"
                                            onClick={() => GetMonitoramento()}
                                        >
                                            Filtrar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                            <Row className="mt-2">
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Total de Alertas
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="totalAlertas"
                                            value={monitoramento != null ? monitoramento.totalAlertas : 0}
                                            type="text"
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Total de Ordens em Execução
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="totalExecucao"
                                            value={monitoramento != null ? monitoramento.totalOSExecucao : 0}
                                            type="text"
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Total de Ordens Finalizadas
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="totalFinalizadas"
                                            value={monitoramento != null ? monitoramento.totalExecucaoFinalizada : 0}
                                            type="text"
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Total de Locais em Execução
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="totalEmExecucao"
                                            value={monitoramento != null ? monitoramento.totalPontosColetadosEmExecucao : 0}
                                            type="text"
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Total de Locais Executados
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="totalPontos"
                                            type="text"
                                            value={monitoramento != null ? monitoramento.totalPontosColetadosExecutados : 0}
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Total de Locais Não Executados
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="totalPontosNaoExecutados"
                                            value={monitoramento != null ? monitoramento.totalPontosColetadosNaoExecutado : 0}
                                            type="text"
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="3">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Delimitação
                                        </label>
                                        <Select
                                            options={options_delimitacao}
                                            name="delimitacao"
                                            onChange={(e) => { handleDelimitacao(e.value) }}
                                            value={options_delimitacao.find(obj => obj.value === delimitacao)}
                                            placeholder="Selecione"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="1" className="text-right mt-4">
                                    <Button className="info" onClick={() => OpenTV()}><FontAwesomeIcon icon={faTv} /></Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">
                                    <div className="custom-control custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="ckVisualizasrPontos"
                                            type="checkbox"
                                            onClick={(e) => {
                                                setDadosRastreamento([]);
                                                setLineRastreio([]);
                                                setviewPontos(e.target.checked)
                                            }}
                                            checked={viewPontos}
                                        />
                                        <label className="custom-control-label" htmlFor="ckVisualizasrPontos">
                                            Visualizar Locais de Execução
                                        </label>
                                    </div>
                                </Col>
                                <Col md="3">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="ckVisualizaralertas"
                                            type="checkbox"
                                            defaultChecked
                                            onClick={(e) => {
                                                setviewAlertas(e.target.checked)
                                                setDadosRastreamento([]);
                                                setLineRastreio([]);
                                            }}
                                            checked={viewAlertas}
                                        />
                                        <label className="custom-control-label" htmlFor="ckVisualizaralertas">
                                            Visualizar Alertas
                                        </label>
                                    </div>
                                </Col>
                                <Col md="3">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="ckVisualizarInconformidades"
                                            type="checkbox"
                                            defaultChecked
                                            onClick={(e) => {
                                                setviewInconformidade(e.target.checked)
                                                setDadosRastreamento([]);
                                                setLineRastreio([]);
                                            }}
                                            checked={viewInconformidade}
                                        />
                                        <label className="custom-control-label" htmlFor="ckVisualizarInconformidades">
                                            Visualizar Inconformidades
                                        </label>
                                    </div>
                                </Col>
                                <Col md="3">
                                    <div className="custom-control custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="ckVisualizarVeiculos"
                                            type="checkbox"
                                            onClick={(e) => setviewRota(e.target.checked)}
                                            checked={viewRota}
                                        />
                                        <label className="custom-control-label" htmlFor="ckVisualizarVeiculos">
                                            Localizar Recurso
                                        </label>
                                    </div>
                                </Col>

                            </Row>
                            <Row>
                                <Col md="12">
                                    <div id="map">
                                        <Map center={centerMap} zoom={12} style={{ zIndex: "0" }}>
                                            {mapaSatelite &&
                                                <ReactLeafletGoogleLayer
                                                    googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }}
                                                    type={'satellite'}
                                                />
                                            }
                                            {!mapaSatelite &&
                                                <TileLayer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                />
                                            }
                                            {
                                                delimitacao == "Regional" && regionalJson != null && regionalJson.filter(f => regional.length == 0 || regional.filter(r => r.regionalId == f.regionalId).length > 0)
                                                    .map(item => (
                                                        <GeoJSON
                                                            key={item.regionalIdId}
                                                            data={JSON.parse(item.geoJson)}
                                                        />
                                                    ))
                                            }

                                            {
                                                delimitacao == "Território" && territorioJson != null && territorioJson.filter(f => regional.length == 0 || regional.filter(r => r.regionalId == f.regionalId).length > 0)
                                                    .map(item => (
                                                        <GeoJSON
                                                            key={item.territorioId}
                                                            data={JSON.parse(item.geoJson)}
                                                        />
                                                    ))
                                            }

                                            {
                                                delimitacao == "Plano" && planoTrabalhoJson != null &&
                                                planoTrabalhoJson?.map((value) => (
                                                    <GeoJSON
                                                        key={value.delimitacaoGeograficaSetorId}
                                                        data={JSON.parse(value.geoJson)}
                                                        onclick={() => {
                                                            loadResumoSetor(value)
                                                        }}
                                                    />
                                                )
                                                )

                                            }
                                            <MarkerClusterGroup>
                                                {acoesColetoCorrencia.length > 0 && checkAcoesColetoOcorrencia &&
                                                    acoesColetoCorrencia.map((m) => {
                                                        return <Marker key={m.ordemColetaAcaoColetorId} position={[m.latitude, m.longitude]} icon={handleIconAcoesColetor(m)}
                                                            onClick={() => openModalAcoesColetor(m)}>
                                                        </Marker>
                                                    })
                                                }
                                            </MarkerClusterGroup>

                                            {modalAcoesMonitoramnento && resumoSetorColeta && <Modal
                                                isOpen={modalAcoesMonitoramnento}
                                                toggle={toggleModalLocalizarRecurso}

                                            >
                                                <ModalBody>
                                                    <div className="d-flex align-items-center justify-content-center ">
                                                        <h2>
                                                            {resumoSetorColeta?.planoTrabalho ?? "Ordem Avulsa"}
                                                        </h2>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        Resumo do Setor
                                                    </div>
                                                    <Progress
                                                        className="my-2"
                                                        value={resumoSetorColeta?.porcetagemColeta}
                                                        style={{
                                                            height: '20px'
                                                        }}
                                                    >
                                                        {resumoSetorColeta?.porcetagemColeta?.toFixed(2)}% executado
                                                    </Progress>
                                                    <Row>
                                                        <Col
                                                            md={6}
                                                            lg={6}
                                                            style={{ cursor: "pointer" }}
                                                            className="mt-2"
                                                            onClick={() => {
                                                                loadOrdemColeta(resumoSetorColeta?.ordemColetaId);
                                                                toggleModalLocalizarRecurso();
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faList} className="mr-1" /> <span>Ações do Coletor</span>
                                                        </Col>
                                                        <Col md={6} lg={6} className="mt-2">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    className="custom-control-input"
                                                                    id="ckAcoesColetoOcorrencia"
                                                                    type="checkbox"
                                                                    onClick={(e) => {
                                                                        setCheckAcoesColetoOcorrencia(e.target.checked)
                                                                        loadAcoesColetoCorrencia(resumoSetorColeta?.ordemColetaId);
                                                                    }}
                                                                    value={checkAcoesColetoOcorrencia}
                                                                />
                                                                <label className="custom-control-label" htmlFor="ckAcoesColetoOcorrencia">
                                                                    Ações Coletor/Ocorrências
                                                                </label>
                                                            </div>
                                                        </Col>
                                                        <Col md={6} lg={6} className="mt-2">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    className="custom-control-input"
                                                                    id="ckRastreiaRecurso"
                                                                    type="checkbox"
                                                                    onClick={(e) => {
                                                                        setRastreiaRecurso(e.target.checked);
                                                                        loadRastreamentoVeiculo(resumoSetorColeta?.ordemColetaId, e.target.checked);
                                                                    }}
                                                                    value={rastreiaRecurs}
                                                                />
                                                                <label className="custom-control-label" htmlFor="ckRastreiaRecurso">
                                                                    Rastrear Recursos
                                                                </label>
                                                            </div>
                                                        </Col>
                                                        <Col
                                                            md={6}
                                                            lg={6}
                                                            className="mt-2"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => { window.open(`/mapaordem/analiseordemmap?id=${resumoSetorColeta.ordemColetaId}`, "_blank") }}
                                                        >
                                                            <FontAwesomeIcon icon={faSearch} /> <span>Detalhes da Ordem</span>
                                                        </Col>
                                                    </Row>
                                                </ModalBody>
                                            </Modal>}
                                            {(viewPontos && monitoramento != null) && monitoramento.monitoramentoOrdemColeta.map((m) => {
                                                return m.monitoramentoPontoColetas.map((i) => {
                                                    return <Marker
                                                        key={i.ordemColetaPontoColetaId}
                                                        position={[i.latitude, i.longitude]}
                                                        icon={handleIconColeta(i)}
                                                        onclick={() => { loadPontoColeta(i.ordemColetaPontoColetaId) }}
                                                    />
                                                })
                                            })}

                                            {(viewAlertas && monitoramento != null) && monitoramento.monitoramentoOrdemColeta.map((m) => {
                                                return m.monitoramentoOrdemColetaInconformidades.filter(x => x.categoria == "Alerta").map(i => {
                                                    return <Marker
                                                        key={i.ordemColetaInconformidadeId}
                                                        position={[i.latitude, i.longitude]}
                                                        icon={handleIconAlerta(i)}
                                                        onClick={() => openModalDetalhesInconformidade(i)}
                                                    >
                                                    </Marker>
                                                })
                                            })}

                                            {(viewInconformidade && monitoramento != null) && monitoramento.monitoramentoOrdemColeta.map((m) => {
                                                return m.monitoramentoOrdemColetaInconformidades.filter(x => x.categoria == "Inconformidade").map(i => {
                                                    return <Marker
                                                        key={i.ordemColetaInconformidadeId}
                                                        position={[i.latitude, i.longitude]}
                                                        icon={handleIconInconformidade(i)}
                                                        onClick={() => openModalDetalhesInconformidade(i)}
                                                    >
                                                    </Marker>
                                                })
                                            })}

                                            {rastreiaRecurs && lineRastreio.length > 0 && delimitacao == "Plano" &&
                                                lineRastreio.map(m => {
                                                    return <Polyline
                                                        key={m.id}
                                                        positions={[[m.from_lat, m.from_long], [m.to_lat, m.to_long]]} color={'red'} />
                                                })
                                            }

                                            {rastreiaRecurs && dadosRastreamento.length > 0 && delimitacao == "Plano" &&
                                                dadosRastreamento.map((m, index) => {
                                                    return <Marker key={index} position={[m.latitude, m.longitude]} icon={handleIconRastreio()}>
                                                        <Tooltip
                                                            direction='center'
                                                            className={"leaflet-tooltip-red"}
                                                            offset={[0, 0]}
                                                            opacity={1}
                                                            permanent
                                                        >
                                                            <span>{m.sequencia}</span>
                                                        </Tooltip>
                                                        <Popup>
                                                            {formateDateandTimeComplete(m.dataHoraGPS)}
                                                        </Popup>
                                                    </Marker>
                                                })
                                            }

                                            {modalRastreiaRecurso && <ModalMarkup />}
                                            {(viewRota && monitoramento != null) && monitoramento.monitoramentoOrdemColeta.filter(f => f.latitudeVeiculo != null && f.latitudeVeiculo != "").map((m) => {
                                                return <Marker key={m.ordemColetaId} position={[m.latitudeVeiculo, m.longitudeVeiculo]} icon={handleIconLocalizaRecurso()}
                                                    onclick={() => {
                                                        setDadoVeiculo({
                                                            datahora: m.dataHoraGPS,
                                                            placa: m.placaVeiculo,
                                                            tipoRastreio: m.origemRastreio
                                                        })
                                                        setModalRastreiaRecurso(true);
                                                    }}>

                                                    <Tooltip direction='center' offset={[-10, -15]} opacity={1} permanent>
                                                        <span>{m.placaVeiculo}</span>
                                                    </Tooltip>
                                                </Marker>
                                            }
                                            )}
                                        </Map>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col md="6">
                                    <Button color="info"
                                        outline
                                        className="btn-sm"
                                        type="button"
                                        onClick={() => setShowLegendas(!showLegendas)}>
                                        Legendas
                                    </Button>
                                </Col>
                                <Col md="6 text-right">
                                    <Button
                                        color="info"
                                        outline
                                        className="btn-sm"
                                        type="button"
                                        onClick={() => setmapaSatelite(!mapaSatelite)}>
                                        {mapaSatelite ? "Mapa" : "Satélite"}
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" className="text-center">
                                    <label className="form-control-label"></label>
                                    <FormGroup>
                                        <Button
                                            color="warning"
                                            type="button"
                                            onClick={() => { history.goBack() }}>
                                            Voltar
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>

                            {showLegendas &&
                                <div>
                                    <Row className="mt-2">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Coleta
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/veiculo-azul.png')}
                                            />
                                            <br />
                                            <label className="form-control-label">Coleta Programada</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/veiculo-roxo.png')}
                                            />
                                            <br />
                                            <label className="form-control-label">Execução Iniciada</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/veiculo-amarelo.png')}
                                            />
                                            <br />
                                            <label className="form-control-label">Execução Parcial</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/veiculo-verde.png')}
                                            />
                                            <br />
                                            <label className="form-control-label">Execução Total</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/veiculo-vermelho.png')}
                                            />
                                            <br />
                                            <label className="form-control-label">Não Execução</label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Alertas
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-azul.png')}
                                            />
                                            <br />
                                            <label>Aguardando Contestação</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-amarelo.png')}
                                            />
                                            <br />
                                            <label>Contestado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-roxo.png')}
                                            />
                                            <br />
                                            <label>Justificado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-verde.png')}
                                            />
                                            <br />
                                            <label>Aprovado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-vermelho.png')}
                                            />
                                            <br />
                                            <label>Reprovado</label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Inconformidade
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-azul.png')}
                                            />
                                            <br />
                                            <label>Aguardando Contestação</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-amarelo.png')}
                                            />
                                            <br />
                                            <label>Contestado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-roxo.png')}
                                            />
                                            <br />
                                            <label>Justificado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-verde.png')}
                                            />
                                            <br />
                                            <label>Aprovado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-vermelho.png')}
                                            />
                                            <br />
                                            <label>Reprovado</label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Ações Coletor
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-start.png')}
                                            />
                                            <br />
                                            <label>Início da Execução</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-pause.png')}
                                            />
                                            <br />
                                            <label>Pausa na Execução</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-close.png')}
                                            />
                                            <br />
                                            <label>Suspensão/Finalização</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-destination.png')}
                                            />
                                            <br />
                                            <label>Destinação</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-unload.png')}
                                            />
                                            <br />
                                            <label>Descarregar</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-ocurrency.png')}
                                            />
                                            <br />
                                            <label>Ocorrência</label>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        </CardBody>
                    </Card>
                </Container>
            </div>

            {stateModalAcaoGesto && ordemColeta &&
                <ModalAcoesColetor
                    stateModalAcoesColetor={stateModalAcaoGesto}
                    ordemColeta={ordemColeta}
                    handleReturn={toggleModalAcaoGesto}
                    ordemColetaAcaoColetorId={ordemColetaAcaoColetorId}
                />
            }

            {pontoColetaSituacao && modalPontoColeta &&
                <ModalDetalhesColetaItem
                    stateModalDetalhesColetaItem={modalPontoColeta}
                    item={pontoColetaSituacao}
                    handleReturn={toggleModalPontoColeta}
                />
            }

            {stateModalDetalhesInconformidade &&
                <ModalDetalhesInconformidade
                    stateModalDetalhesInconformidade={stateModalDetalhesInconformidade}
                    item={itemModalDetalhesInconformidade}
                    handleReturn={ReturnModalDetalhesInconformidade}
                />
            }
        </>
    );
}
